import { render } from "./ExpertCard.vue?vue&type=template&id=3143c114&scoped=true"
import script from "./ExpertCard.vue?vue&type=script&lang=js"
export * from "./ExpertCard.vue?vue&type=script&lang=js"

import "./ExpertCard.vue?vue&type=style&index=0&id=3143c114&lang=sass&scoped=true"
import "./ExpertCard.vue?vue&type=style&index=1&id=3143c114&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3143c114"]])

export default __exports__